import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { SnMessage } from '../../../models';

@Component({
  selector: 'sn-message-timestamp',
  templateUrl: './message-timestamp.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnMessageTimestampComponent {
  @Input() public message: SnMessage;

  constructor() {}
}
